module.exports = __webpack_public_path__ + "static/logo-white-7be1fd4c7076877469313f4f11685fd3.svg";